import { MouseEvent, useEffect } from 'react'

import AuthUtils from '@/utils/AuthUtils'
import { useIsAuthenticated } from '@azure/msal-react'
import Logo from '@components/Logo/Logo'
import { Box, Button, Container, Stack, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Login page
 */
export default function Login() {
	const navigate = useNavigate()
	const location = useLocation()

	const isAuthenticated = useIsAuthenticated()

	const handleLogin = async (e: MouseEvent<HTMLButtonElement>) => {
		e.preventDefault()
		try {
			await AuthUtils.ssoLogin()
			if (location) {
				navigate(location.pathname, { replace: true })
				return
			}
			navigate('/app', { replace: true })
		} catch (error) {
			console.error('Error logging in', error)
		}
		// AuthUtils.ssoLogin()
	}

	useEffect(() => {
		if (isAuthenticated) {
			navigate('/app', { replace: true })
		}
	}, [isAuthenticated, navigate])

	return (
		<>
			<Box
				sx={{
					bgcolor: 'secondary.main',
					boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.25)',
					height: '54px',
				}}
			/>
			<Container
				sx={{ height: '90vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
			>
				<Stack direction="column" sx={{ alignItems: 'center' }} gap={2}>
					<Logo width="20%" />
					<Typography variant="h6">Welcome to Artemis</Typography>
					<Typography pb="2rem">
						<b>Sign in with your Buyers Edge credentials</b>
					</Typography>
					<Button variant="contained" color="secondary" onClick={handleLogin}>
						Sign in with Microsoft
					</Button>
				</Stack>
			</Container>
		</>
	)
}
